module.exports = __webpack_public_path__ + "_/_/_/node_modules/@reverbdotcom/discovery-ui/images/app-store-badges/apple-app-store-de-f419ad8debd410e046326d36aaa24f43.svg";


//////////////////
// WEBPACK FOOTER
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/discovery-ui/images/app-store-badges/apple-app-store-de.svg
// module id = IM3u
// module chunks = 22 24